import React, { useEffect, useRef } from 'react';
import { useFileTree } from './FileTreeContext';

interface FileTreeInitializerProps {
  children: React.ReactNode;
  currentUser?: any;
}

const FileTreeInitializer: React.FC<FileTreeInitializerProps> = ({ children, currentUser }) => {
  const { refreshTreeData, treeData } = useFileTree();
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Only initialize once when user is available and tree data hasn't been loaded
    if (currentUser && !treeData && !hasInitialized.current) {
      console.log('Triggering refreshTreeData (once)...');
      hasInitialized.current = true;
      refreshTreeData();
    }
  }, [currentUser, treeData, refreshTreeData]);

  return <>{children}</>;
};

export default FileTreeInitializer;
